import axios from "axios";

export const uploadImages = async (formData, path, token) => {
  try {
    const { data } = await axios.post(`/uploadImages`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "content-type": "multipart/form-data",
      },
    });
    return data;
  } catch (error) {
    return error.response?.data?.message || error.message || "Failed to upload images";
  }
};
// uploadImages.js

// /**
//  * Uploads images to the server.
//  *
//  * @param {FormData} formData - The form data containing images.
//  * @param {string} path - The path where the images will be uploaded.
//  * @param {string} token - The authorization token for the request.
//  * @returns {Promise} - A promise that resolves with the server response.
//  */
// export const uploadImages = async (formData, path, token) => {
//     try {
//       const response = await fetch(`/api/upload?path=${path}`, {
//         method: 'POST',
//         headers: {
//           'Authorization': `Bearer ${token}`,
//           // Other headers if needed, e.g., 'Content-Type': 'multipart/form-data'
//         },
//         body: formData,
//       });

//       if (!response.ok) {
//         throw new Error('Failed to upload images');
//       }

//       const data = await response.json();
//       return data; // Return the server response
//     } catch (error) {
//       console.error('Error uploading images:', error);
//       throw error; // Rethrow the error to be handled in the calling function
//     }
//   };
